/**
 * Component Entry
 *
 */

import NumberFormat from './NumberFormat'
export default NumberFormat
export * from './NumberFormat'
